import firebase from './firebase'

export const signIn = async (emailAddress, password) => {
  try {
    await firebase.auth().signInWithEmailAndPassword(emailAddress, password)
  } catch (error) {
    switch (error.code) {
      case 'auth/user-not-found':
      case 'auth/wrong-password':
        throw new Error('Wrong email address or password')
      case 'auth/too-many-requests':
        throw new Error('Too many requests, please slow down and try again later')
      default:
        throw new Error('Oops, something went wrong.')
    }
  }
}

export const signOut = () =>
  firebase.auth().signOut()

export const passwordReset = (email) =>
  firebase.auth().sendPasswordResetEmail(email)

export const passwordUpdate = (currentPassword, newPassword) =>
  firebase.auth().signInWithEmailAndPassword(firebase.auth().currentUser.email, currentPassword)
    .then(() => firebase.auth().currentUser.updatePassword(newPassword))

export const getIdToken = () =>
  firebase.auth().currentUser.getIdToken()


// WEBPACK FOOTER //
// ./src/firebase/auth.js